var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 283,
    viewBox: "0 0 153 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C25.4967 21.0265 32.5828 52.2172 40.9069 81.4277C57.7936 140.686 55.8302 186.531 86 241C96.4918 258.288 102 266.5 112.5 283",
    stroke: "#F5EAD2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M151.5 283C137.827 263.761 125.847 246.74 111.472 228.008C95.1361 206.719 82.212 183.151 63.606 163.326C45 143.5 0.5 125.5 0.5 125.5",
    stroke: "#C9C1AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line1.e0c3a9b94e22ccb889d2376a1def1952.svg";
export { ForwardRef as ReactComponent };